import { standardCachingQueryOptions } from 'pos-client/utils/standardCachingQueryOptions.ts';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useRoles = () => {
  const { data: roles } = trpc.getUserRoles.useQuery(
    undefined,
    standardCachingQueryOptions
  );

  return { roles };
};
